import React, { PureComponent, RefObject, createRef } from 'react';
import { noop } from 'lodash';

import { InstagramMetadata } from 'api';
import { INSTAGRAM_ENDPOINT, INSTAGRAM_URL } from '../constants';
import { FACEBOOK_APP_ID, FACEBOOK_CLIENT_ID } from 'settings';

interface IOembedResponse {
  html: string;
}

interface IProps {
  shortcode: InstagramMetadata['shortcode'];
}

class EmbedInstagram extends PureComponent<IProps> {
  container: RefObject<HTMLDivElement>;

  constructor(props: IProps) {
    super(props);
    this.container = createRef();
  }

  componentDidMount() {
    this.loadPost();
  }

  loadPost() {
    const { shortcode } = this.props;

    fetch(
      `${INSTAGRAM_ENDPOINT}?url=${INSTAGRAM_URL}/${shortcode}/&access_token=${FACEBOOK_APP_ID}|${FACEBOOK_CLIENT_ID}&omitscript=true`
    )
      .then(response => response.json())
      .then(this.writeEmbed)
      .catch(noop);
  }

  writeEmbed = ({ html }: IOembedResponse) => {
    this.container.current.innerHTML = html;
    window.instgrm && window.instgrm.Embeds.process();
  };

  render() {
    return <div ref={this.container} />;
  }
}

export default EmbedInstagram;
